import React, { useState } from 'react'
import { styled } from '@mui/material'
import Box from '@mui/material/Box'
import DoughnutChart from '../Charts/DonutChart/DoughnutChart'

const idleTimeDataMapper = (data, timePeriod) => {

  const periodData = data[timePeriod]
  const chartData = []

  for (const [reason, valueObj] of Object.entries(periodData)) {
    if (valueObj?.time > 0) {
      chartData.push({
        label: reason,
        value: valueObj.time,
        color: valueObj.color
      })
    }
  }

  chartData.sort((a, b) => b.value - a.value)

  return {
    labels: chartData.map((el) => el.label),
    values: chartData.map((el) => el.value),
    colors: chartData.map((el) => el.color)
  }
}

const Container = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  border: '1px solid lightgray',
  borderRadius: '12px',
}))

const CardHeader = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '12px',
  borderBottom: '1px solid lightgray'
}))

const CardBody = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '12px'
}))

const CardFooter = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  borderTop: '1px solid lightgray',
  padding: '12px'
}))

const SelectBox = styled('select')(() => ({
  borderRadius: '4px',
  padding: '4px 8px',
}))

const IdleTimeDoughnut = ({ idleTimeData }) => {
  const [timePeriod, setTimePeriod] = useState('day')

  if (!idleTimeData || Object.keys(idleTimeData).length === 0) {
    return (
      <Container>
        <CardBody>
          <p>No idle time data available</p>
        </CardBody>
      </Container>
    )
  }

  const chartData = idleTimeDataMapper(idleTimeData, timePeriod)
  const totalCount = chartData.values.reduce((acc, val) => acc + val, 0)

  return (
    <Container>
      <CardHeader>
        <h3>Idletime data</h3>
        <Box>
          <SelectBox
            value={timePeriod}
            onChange={(e) => setTimePeriod(e.target.value)}
          >
            <option value="shift1">Shift 1</option>
            <option value="shift2">Shift 2</option>
            <option value="shift3">Shift 3</option>
            <option value="day">Day</option>
          </SelectBox>
        </Box>
      </CardHeader>
      <CardBody>
        {totalCount > 0 ? (
          <DoughnutChart
            chartLabels={chartData.labels}
            dataGroup={chartData.values}
            backgroundColors={chartData.colors}
          />
        ) : (
          <p>
            No idle time recorded for{' '}
            {timePeriod === 'day'
              ? 'the day'
              : timePeriod === 'shift1'
                ? 'Shift 1'
                : 'Shift 2'}
          </p>
        )}
      </CardBody>
      <CardFooter>
        <h4>Total Idletime: {totalCount} minutes</h4>
      </CardFooter>
    </Container>
  )
}

export default IdleTimeDoughnut
